import { Capacitor } from "@capacitor/core";
import { initPushManager } from "../_Push/pushManager";

const isNativePlatform = () =>
  typeof Capacitor !== "undefined" &&
  typeof Capacitor.isNativePlatform === "function" &&
  Capacitor.isNativePlatform();

export const isNativePushSupported = () => isNativePlatform();

export const safeRegisterPush = async (ctx = {}) => {
  try {
    await initPushManager(ctx);
  } catch (error) {
    console.warn("[push] Falló safeRegisterPush", error);
  }
};

export const initPushNotifications = safeRegisterPush;
export const registerDeviceToken = async () => {};
